









































































import Vue from "vue";
import Email from "@/modules/cashStatement/models/Email";
import http from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import CheckBox from "@/components/CheckBox.vue";
import IconButton from "@/components/IconButton.vue";
import eventBus from "@/services/eventBus";
import store, { BankStatementStore } from "../services/BankStatementStore";
import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";

interface Data {
  emails: Email[];
  isCreating: boolean;
  newItem: Email;
  isLoading: boolean;
  selectedEmails: Email[];
  store: BankStatementStore;
}

interface Props {
  code: string;
  partnerID: number;
}

interface Methods {
  getEmails(): Promise<Email[]>;
  isSelected(email: Email): boolean;
  setSelected(email: Email): void;
  setEmail(email: Email, value: object): void;
  emailRules(value: string): string;
  saveEmail(): void;
}

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    CheckBox,
    IconButton,
  },

  props: {
    code: String,
    partnerID: Number,
  },

  async beforeMount() {
    this.emails = await this.getEmails().then((x) => {
      this.selectedEmails.push(
        ...x.filter((y) => y.isPrimary)
      );
      return x;
    });

    this.$emit("emails", this.selectedEmails);
  },

  data: () => {
    return {
      emails: new Array<Email>(),
      isCreating: false,
      newItem: new Email(),
      isLoading: false,
      selectedEmails: [],
      store
    };
  },

  methods: {
    async saveEmail() {
      if (this.emailRules(this.newItem.email) == '') {
          this.emails.push(this.newItem);
          this.isCreating = false;          
        }
    },

    emailRules(value: string) {
      if (value.length < 1) {
        return "Kötelező kitölteni!";
      }

      return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        value.toLowerCase()
      )
        ? ""
        : "Hibás e-mail cím!";
    },

    setEmail(email, value) {
      email.email = String(value);
    },

    setSelected(email) {
      email.isSelected = !email.isSelected;
      if (this.selectedEmails.includes(email)) {
        this.selectedEmails = this.selectedEmails.filter(
          (x) => x.email !== email.email
        );
        return;
      }
      this.selectedEmails.push(email);
      this.$emit("emails", this.selectedEmails);
    },

    isSelected(email) {
      return this.selectedEmails.map((x) => x.email).includes(email.email);
    },

    async getEmails() {
      const emails = await this.store.getSelectableEmails(
        this.$props.partnerID,
        this.$props.code
      );
      return emails;
    },
  },
});
